module.exports = __webpack_public_path__ + "static/scale-model-of-la-maison-de-begnaud-in-lafayette-louisiana-8fa01d4005d67763c03879949c35c0ed.png";